module.exports = __webpack_public_path__ + "img/logo.adb20a6b.svg";